import { Injectable } from '@angular/core';

interface Umami {
    // Tracks the current page
    track(): void;

    // Custom payload
    track(payload: object): void;

    // Custom event
    track(event_name: string): void;

    // Custom event with data
    track(event_name: string, data?: object): void;

    // Assign ID to current session
    identify(unique_id: string): void;

    // Session data
    identify(unique_id: string, data: object): void;

    // Session data without ID
    identify(data: object): void;
}

declare const umami: Umami;

@Injectable({
    providedIn: 'root',
})
export class UmamiService {
    public trackPage() {
        if (typeof umami === 'undefined') {
            return;
        }
        umami.track();
    }

    public trackEvent(name: string, data?: object) {
        if (typeof umami === 'undefined') {
            return;
        }
        umami.track(name, data);
    }

    public trackCheckoutCart(revenue: number) {
        if (typeof umami === 'undefined') {
            return;
        }
        umami.track('checkout-cart', { revenue: revenue, currency: 'CZK' });
    }

    public identifySession(uniqueId: string, data?: object) {
        if (typeof umami === 'undefined') {
            return;
        }
        if (data) {
            umami.identify(uniqueId, data);
        } else {
            umami.identify(uniqueId);
        }
    }
}
